export const translations = {
	'Team tags override user tags': {
		no: 'Teamtagger overstyrer personlige etiketter',
	},
	'These tags are forced and cannot be modified': {
		no: 'Disse etikettene er pÃ¥krevde og kan ikke endres',
	},
	'These tags are forced by your team and user settings': {
		no: 'Etiketter er pÃ¥krevd av team og brukerinnstillingene dine',
	},
	ON: {
		no: 'ON',
	},
	OFF: {
		no: 'OFF',
	},
	MODAL_INFO_ROW: {
		en: 'Tags are used to filter content in Ceeview.\r\nUser tags are set per user and is controlled by that user.\r\nTeam tags are set per team. If user has checked Force Team Tags the tags will be applied on login.\r\nUser canât change Tags from this form. It is changed from Team or by removing Force Team tags.',
		no: 'Etiketter brukes til Ã¥ filtrere innholdet i Ceeview.\r\nBrukeretiketter settes per bruker og kontrolleres av brukeren.\r\nTeametiketter settes per Team. Hvis brukeren har PÃ¥tving Teametiketter valgt, vil de bli brukt ved pÃ¥logging. Brukeren kan ikke endre Teametiketter fra dette vinduet. MÃ¥ gjÃ¸res via teams eller ved Ã¥ fjerne PÃ¥tving Teametiketter.',
	},
	'Include Untagged': {
		no: 'Vis uten etikett',
		en: 'Include untagged',
	},
	Tags: {
		no: 'Etiketter',
	},
	'Vis subkonto etiketter': {
		no: 'Vis subkonto etiketter',
	},
	'Team and user tags active': {
		no: 'Team og brukeretiketter aktiv',
	},
	'User tags active': {
		no: 'brukeretiketter aktiv',
	},
	'Team tags active': {
		no: 'Team etiketter aktiv',
	},
	'Show subaccount tags': {
		no: 'Vis subkonto etiketter',
	},
};
